export default __webpack_public_path__ + "static/use-case-4.url-97962f6f437ea4aff0c43662a43ebb75.svg";